
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useState, useEffect } from "react";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";
import { setUserData, setLoading } from "../../redux/signIn";
import { signInFB } from "../../services/facebook";
import NarrowPage from "../../components/layout/narrow-page";
import AppleButton from "../../components/ui/apple-button";
import Alert from "../../components/ui/alert";
import FacebookButton from "../../components/ui/facebook-button";
import Head from "next/head";
import Script from "next/script";
import { generateId } from "../../util/generateId";
import styles from "@/modules/register/styles/Register.module.css";
import { setLoadingBar } from "../../redux/siteData";
import { api } from "../../services/api";
import { useRouter } from "next/router";
import { signInAppleWeb } from "../../services/apple";
import FBScript from "@/components/util/fb-script";
import { Button } from "@/components/ui/button";
export default function SignIn() {
    // const [rememberMe, setRememberMe] = useState(false);
    const [username, setUsername] = useState(null);
    const [password, setPassword] = useState(null);
    const [error, setError] = useState(null);
    const { t } = useTranslation("common");
    const { t: registerT } = useTranslation("auth");
    const router = useRouter();
    function sendSignIn() {
        setLoadingBar(true);
        const { premium } = router.query;
        // setTimeout(() => {
        api
            .post("/auth/signin/" + router.locale, {
            username,
            password,
            // rememberMe,
            premium,
        })
            .then((response) => {
            if (response.status >= 400) {
                throw response.status;
            }
            setUserData(response.data);
            if (response.data.premiumUpgrade) {
                router.push("/premium/welcome");
            }
            else {
                router.push("/lobby");
            }
        })
            .catch(() => {
            if (error) {
                setError(null);
                setTimeout(() => {
                    setError(true);
                }, 300);
            }
            else {
                setError(true);
            }
        })
            .then(() => {
            setLoadingBar(false);
        });
        // }, 1000);
    }
    function handleKeyDown(e) {
        if (e.key === "Enter") {
            sendSignIn();
        }
    }
    function signInOrWillCreateGoogleUser(credential: string) {
        const { premium } = router.query;
        api
            .post("/auth/google/token", { credential, premium })
            .then((response) => {
            if (response.status === 200 && response.data) {
                // User exists, sign them in
                if (response.data.premiumUpgrade) {
                    router.push("/premium/welcome");
                }
                else {
                    router.push("/lobby");
                }
                setUserData(response.data);
                setLoading(false);
            }
            else if (response.status === 204) {
                // User doesn't exist, redirect to register
                router.push(`/register?accountType=google&credential=${credential}`);
            }
        })
            .catch(() => {
            setLoading(false);
            if (error) {
                setError(null);
                setTimeout(() => {
                    setError(true);
                }, 300);
            }
            else {
                setError(true);
            }
        })
            .then(() => {
            setLoadingBar(false);
        });
    }
    function initializeGoogleButton() {
        const g = (window as any).google;
        if (!g?.accounts?.id)
            return;
        const clientId = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID;
        if (!clientId)
            return;
        g.accounts.id.initialize({
            client_id: clientId,
            callback: (res: any) => {
                setLoadingBar(true);
                signInOrWillCreateGoogleUser(res.credential);
            },
            // Prefer FedCM to avoid popup/opener dependency on COOP/COEP pages
            use_fedcm_for_prompt: true,
        });
        const gbtn = document.getElementById("gbtn");
        let buttonWidth = 0;
        if (window.innerWidth > 480) {
            buttonWidth = Math.min(400, window.innerWidth - 42);
        }
        else {
            buttonWidth = window.innerWidth - 82;
        }
        if (gbtn) {
            // Clear any existing button content before rendering
            gbtn.innerHTML = "";
            g.accounts.id.renderButton(gbtn, {
                theme: "outline",
                size: "large",
                width: buttonWidth,
                longtitle: true,
                text: "signin_with",
                logo_alignment: "left",
            });
        }
    }
    useEffect(() => {
        // Initialize Google button when component mounts or when navigating to this page
        // Check if Google script is already loaded
        if ((window as any).google?.accounts?.id) {
            initializeGoogleButton();
        }
        else {
            // If not loaded yet, wait a bit and try again
            const checkInterval = setInterval(() => {
                if ((window as any).google?.accounts?.id) {
                    clearInterval(checkInterval);
                    initializeGoogleButton();
                }
            }, 100);
            // Cleanup after 5 seconds if script doesn't load
            setTimeout(() => clearInterval(checkInterval), 5000);
        }
    }, [router.locale]);
    return (<>
      <Head>
        <title>{"Chess Hotel | " + t("Log in")}</title>
        <meta name="description" content={t("description")}/>
        <meta name="keywords" content={t("keywords")}/>
      </Head>
      <NarrowPage title={null}>
        <div className="text-lg font-semibold text-center md:text-xl md:text-left">
          {t("Log in")}
        </div>
        {/* <div className="mt-2 text-sm md:text-sm text-altgray-600">
          {registerT("Log in with your favourite account")}
        </div> */}
        <div className="mt-7">
          <FBScript />
          <Script onLoad={() => {
            window.AppleID.auth.init({
                clientId: "com.chesshotel.service",
                scope: "",
                redirectURI: "https://www.chesshotel.com/api/v1/auth/apple/redirect",
                state: "Eksätravägen975031",
                nonce: generateId(),
                usePopup: true,
            });
        }} src="https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js"/>
          <Script src={`https://accounts.google.com/gsi/client?hl=${router.locale}`} strategy="afterInteractive" onLoad={() => {
            initializeGoogleButton();
        }}/>
          <div className={"flex flex-col justify-center items-stretch " + styles.body}>
            <div id="gbtn" className="w-full h-[40px] max-w-[400px] mx-auto"></div>
            <div className="my-1.5"/>
            <div className="flex justify-center items-center md:block">
              <FacebookButton onClick={() => signInFB()} text={t("Log in with Facebook")}/>
            </div>
            <div className={`${styles.appleBtn} flex items-center justify-center md:block`}>
              <AppleButton onClick={() => signInAppleWeb()} text={t("Log in with Apple")}/>
            </div>
            <div className={styles.line}>
              <span>{registerT("or")}</span>
            </div>
            {error && <Alert>{registerT("Wrong username or password")}</Alert>}
            <label htmlFor="username" className={styles.label}>
              {registerT("Username or email")}
            </label>
            <input id="username" autoFocus type="text" onChange={(event) => setUsername(event.target.value)}/>

            <label htmlFor="password" className={styles.label}>
              {t("Password")}
            </label>
            <input id="password" type="password" onChange={(event) => setPassword(event.target.value)} onKeyDown={handleKeyDown}/>

            <div className="flex justify-end mt-2 space-x-4 text-sm">
              <Link className="hover:text-orange-400" href={"/signIn/passwordRecovery"}>
                {registerT("Lost your password?")}
              </Link>
            </div>

            <div className="flex justify-center items-center md:block">
              <Button size="lg" className="py-7 mt-4 w-full text-lg font-bold" onClick={() => sendSignIn()}>
                {t("Log in")}
              </Button>
            </div>

            <div className="flex justify-center items-center mt-4">
              <Link className="text-sm underline hover:text-orange-400" href={"/register"}>
                {t("Sign up")}
              </Link>
            </div>
          </div>
        </div>
      </NarrowPage>
    </>);
}

    async function __Next_Translate__getStaticProps__19d12a5994b__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/signIn/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19d12a5994b__ as getStaticProps }
  